export default class Upload {
  constructor($http) {
    this.onPreUpload = null;
    this.onProgress = null;
    this.onUploadSuccess = null;
    this.onUploadFail = null;
    this.$http = $http;
  }

  upload(nome, form) {
    const formData = new FormData();

    formData.append('nome', nome);
    formData.append('file', form);


    if (this.onPreUpload instanceof Function) {
      this.onPreUpload();
    }
    this.$http({
      method: 'post',
      url: '../../UploadAsp/ToFileSystem.asp',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
      uploadEventHandlers: {
        progress: (e) => {
          if (e.lengthComputable) {
            //console.log(e);
            if (this.onProgress instanceof Function) {
              this.onProgress(e);
            }
          }
        },
      },
      transformRequest: angular.identity,
    }).then((data) => {
      if (this.onUploadSuccess instanceof Function) {
        this.onUploadSuccess(data);
      }
    }).catch((data) => {
      if (this.onUploadFail instanceof Function) {
        this.onUploadFail(data);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/upload.js